<app-loading-spinner [active]="loading"></app-loading-spinner>

<ng-container>
    <form [formGroup]="form" (keydown.enter)="handleKeyEnter($event)">
        <ng-container *ngIf="!showForm">
            <div class="row">
                <div class="col-12 col-lg-8">
                    <app-table [columns]="columns" [data]="data"
                        [haveEdit]="true"
                        (onRemove)="handleOpenRemoveModal($event)"
                        (onEdit)="handleOpenEditModal($event)"></app-table>
                    <app-spacer [bottom]="32"></app-spacer>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="showForm">
            <div class="row">
                <div class="col-12 col-lg-8">
                    <app-select [items]="signupService.choices().banks"
                        [group]="form" controlName="bank" label="Banco">
                    </app-select>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <div class="ng-container" *ngIf="form.controls.bank.value !== null">
                <div class="row">
                    <div class="col-12 col-lg-8">
                        <div class="row">
                            <div class="col-12 col-lg-3">
                                <app-masked-input [group]="form"
                                    controlName="agency" type="text"
                                    label="Agência" placeholder="Digite"
                                    mask="0*">
                                </app-masked-input>

                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-6">
                                <app-masked-input [group]="form"
                                    controlName="account_number" label="Conta"
                                    type="text" placeholder="Digite" mask="0*">
                                </app-masked-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-3">
                                <app-masked-input [group]="form"
                                    controlName="account_digit" label="Dígito"
                                    type="text" placeholder="Digite" mask="9"
                                    [max]="1">
                                </app-masked-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-8">
                        <app-select [items]="accountTypes" [group]="form"
                            controlName="account_type" label="Tipo de conta"
                            placeholder="Selecione">
                        </app-select>
                        <app-spacer [bottom]="54"></app-spacer>
                    </div>
                </div>

                <div class="row" *ngIf="userRole !== 'provider'">
                    <ng-container *ngIf="this.data.length > 0">
                        <div class="col-12">
                            <app-radio [multiple]="true"
                                formControlName="main_account">Conta principal
                            </app-radio>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </ng-container>

                    <div class="col-12" *ngIf="userRole === 'provider'">
                        <app-radio [multiple]="true"
                            formControlName="joint_account">
                            Esta conta é conjunta
                        </app-radio>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <!-- <div class="col-12">
                        <app-radio [multiple]="true"
                            formControlName="not_owner">
                            Não sou o titular desta conta
                        </app-radio>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div> -->
                </div>



                <app-spacer [bottom]="16"></app-spacer>
            </div>

        </ng-container>

        <app-side-modal [active]="addAnotherModal"
            [title]="editingBank ? 'Editar conta bancária' : 'Adicionar conta bancária'"
            (onClose)="handleCloseModal()" paddingBottom="0">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-12">
                        <app-select [items]="signupService.choices().banks"
                            [group]="form" controlName="bank" label="Banco">
                        </app-select>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>

                <div class="ng-container"
                    *ngIf="form.controls.bank.value !== null">
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <app-masked-input [group]="form"
                                controlName="agency" type="text" label="Agência"
                                placeholder="Digite" mask="0*">
                            </app-masked-input>


                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-6">
                            <app-masked-input [group]="form"
                                controlName="account_number" label="Conta"
                                type="text" placeholder="Digite" mask="0*">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>

                        <div class="col-12 col-lg-2">
                            <app-masked-input [group]="form"
                                controlName="account_digit" label="Dígito"
                                type="text" placeholder="Digite" mask="9"
                                [max]="1">
                            </app-masked-input>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <app-select [items]="accountTypes" [group]="form"
                                controlName="account_type" label="Tipo de conta"
                                placeholder="Selecione">
                            </app-select>
                            <app-spacer [bottom]="54"></app-spacer>
                        </div>
                    </div>

                    <div class="row">
                        <ng-container *ngIf="this.data.length > 0">
                            <div class="col-12">
                                <app-radio [multiple]="true"
                                    formControlName="main_account">Conta
                                    principal</app-radio>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </ng-container>

                        <!-- <div class="col-12">
                            <app-radio [multiple]="true"
                                formControlName="not_owner">Não sou o titular
                                desta conta
                            </app-radio>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div> -->
                    </div>


                    <app-spacer [bottom]="24"></app-spacer>

                    <div class="row">
                        <div class="col-12">
                            <app-spacer [bottom]="8"></app-spacer>
                        </div>
                    </div>
                </div>

                <div class="row button-sticky">
                    <div class="col-12 col-lg-6">
                        <app-button (onClick)="handleCloseModal()"
                            class="add-button" [outline]="true"
                            [disabled]="sending">
                            Cancelar
                        </app-button>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="text-right">
                            <app-button (onClick)="triggerForm()"
                                [disabled]="getDisabled() || sending"
                                [loading]="sending" class="add-button">
                                {{ editingBank ? 'Atualizar dados' : 'Salvar
                                conta bancária' }}
                            </app-button>
                        </div>
                    </div>
                </div>
            </div>
        </app-side-modal>

        <app-warning-modal [active]="confirmMainAccountModal"
            (onClose)="handleConfirm(false)">
            <h3>Esta é sua conta principal?
            </h3>

            <app-spacer [bottom]="24"></app-spacer>
            <p>Você ja possui uma conta principal,
                deseja alterar mesmo assim?
            </p>
            <app-spacer [bottom]="56"></app-spacer>

            <app-button (onClick)="handleConfirm(false)" [center]="true"
                class="add-button">
                Cancelar
            </app-button>

            <app-spacer [bottom]="8"></app-spacer>

            <app-button (onClick)="handleConfirm(true)" class="add-button"
                [center]="true" [outline]="true">
                Sim, alterar!
            </app-button>
        </app-warning-modal>

        <app-warning-modal [active]="removeModal"
            (onClose)="handleRemoveCancel()">
            <h3>Você tem certeza?</h3>
            <app-spacer [bottom]="24"></app-spacer>
            <p>Você não poderá reverter essa ação!</p>
            <app-spacer [bottom]="56"></app-spacer>

            <app-button (onClick)="handleRemoveCancel()" [center]="true"
                class="add-button" [disabled]="removingBank">
                Cancelar
            </app-button>

            <app-spacer [bottom]="8"></app-spacer>

            <app-button (onClick)="removeBank(selectedIndex)" class="add-button"
                [center]="true" [outline]="true" [loading]="removingBank">
                Sim, remover
            </app-button>
        </app-warning-modal>

        <div class="row" *ngIf="form.controls.bank.value !== null || !showForm"
            style="margin-top: -8px;">
            <div class="col-12">
                <ng-container *ngIf="data.length === 0">
                    <app-button (onClick)="triggerForm()" [outline]="true"
                        [disabled]="getDisabled() || sending"
                        [loading]="sending" class="button-with-right-icon">
                        <span>Salvar dados bancários</span>
                        <svg-icon src="assets/images/icon-save.svg"></svg-icon>
                    </app-button>
                </ng-container>

                <ng-container *ngIf="data.length > 0">
                    <app-button (onClick)="triggerForm()" *ngIf="!showForm"
                        class="add-button" [outline]="true">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2"></svg-icon>
                        Adicionar outra conta bancária
                    </app-button>
                </ng-container>
            </div>
        </div>
    </form>
</ng-container>